<template>
    <div class="mt-8">
        <transition 
          enter-class="fade-enter"
          enter-to-class="fade-enter-active"
          leave-class="fade-leave-active"
          leave-to-class="fade-leave-to"
          mode="out-in" tag="div" name="project">
            <div class="box-border relative flex flex-col justify-between w-full bg-opacity-25 border-2 border-background-menu">
                <div class="bg-opacity-25 border-b-2 h-72 border-background-menu skill__title">
                    <img :src="data.image" :alt="data.name" class="w-full h-72">
                </div>
                <div class="p-6 bg-opacity-25 border-b-2 skill__description border-background-menu">
                    <p class="uppercase">{{ data.name }}</p>
                    <p>
                        {{ shortDescription(data.description) }}...
                    </p>
                </div>
                <div @click="modal = true" class="absolute justify-end p-2 m-2 text-white border border-t-2 border-b-2 border-l-2 border-r-2 rounded-full cursor-pointer top-64 score bg-tertiary hover:bg-letter-submenu hover:text-quaternary right-5 border-background-menu">
                    <svg viewBox="0 0 20 20" class="w-6 h-6 fill-current">
                        <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
                        <path d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0   012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clip-rule="evenodd" fill-rule="evenodd"></path>
                    </svg>
                </div>
                <div class="p-3 skill__footer">
                    <div class="flex justify-between flex-1 align-middle">
                        <p class="uppercase">Categorias:</p>
                        <div class="flex flex-wrap flex-1 skill__labels">
                            <span v-for="(category, index) in data.categories" :key="index" v-text="category" class="px-2 pt-1 mx-2 text-xs rounded-full bg-tertiary text-letter-profile"></span>
                        </div>
                    </div>
                </div>
                <transition 
                    enter-class="fade-enter"
                    enter-to-class="fade-enter-active"
                    leave-class="fade-leave-active"
                    leave-to-class="fade-leave-to"
                    mode="out-in">
                    <div id="modal" class="absolute top-0 z-50 w-full h-full overflow-y-hidden bg-background" v-if="modal">
                        <vuescroll>
                            <span @click="modal = false" class="absolute top-0 right-0 m-4 cursor-pointer">
                                <svg fill="currentColor" viewBox="0 0 20 20" class="w-6 h-6 fill-current">
                                    <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                                </svg>
                            </span>
                            <div class="p-8">
                                <Header class="inline-block">
                                    <template v-slot:title><span class="text-lg capitalize">Descripción</span></template>
                                </Header>
                                <p class="mb-4">{{ data.description }}</p>
                                <div class="mt-4">
                                    <a :href="data.url" target="_blank" rel="noopener noreferrer" class="hover:font-bold">DEMO</a>
                                    <span v-if="data.code.public"> | </span>
                                    <a :href="data.code.url" target="_blank" rel="noopener noreferrer" class="hover:font-bold" v-if="data.code.public">Codigo</a>
                                </div>
                                <Header class="inline-block">
                                    <template v-slot:title><span class="text-lg capitalize">Tecnologías</span></template>
                                </Header>
                                <div class="flex justify-between flex-1 align-middle">
                                    <div class="flex flex-wrap flex-1 skill__labels">
                                        <span v-for="(tech, index) in data.technologies" :key="index" v-text="tech" class="px-2 mb-2 mr-3 text-xs rounded-full bg-tertiary text-letter-profile"></span>
                                    </div>
                                </div>
                            </div>
                        </vuescroll>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>
<script>
import Header from '../components/Header';
import vuescroll from 'vuescroll';

export default {
    components: {
        Header,
        vuescroll
    },
    props: ['data'],
    data() {
        return {
            modal: false
        }
    },
    methods: {
        shortDescription(text) {
            return text.substring(0, 25);
        }
    }
}
</script>
